import React from "react";
import MainLogo from "../../../../../UI/MainLogo";

const LoginLogo = () => {
    return(
        <div>
            <MainLogo params="text-xl font-bold text-white"/>
        </div>
    );
}

export default LoginLogo;